import React from 'react';
import { Button, Modal } from 'antd';
import { XpIcon } from 'icons';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { setVisibleXpModal } from '../slice';

const XpModal: React.FC<{ totalXp?: number }> = ({ totalXp }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const open = useAppSelector(({ result }) => result.xpModalVisible);

  const onClose = () => {
    dispatch(setVisibleXpModal(false));
  };

  return (
    <Modal open={open} onCancel={onClose} footer={false} centered closable={false}>
      <div className="mt-50 relative flex flex-col items-center justify-center">
        <Image src="/images/xp-image.png" width={300} height={300} alt="xp-images" className="-top-66 absolute" />
        <div className="border-b-6 flex w-full flex-col items-center justify-center rounded-lg border-2 border-solid border-green-600 bg-white p-6">
          <span className="font-medium text-gray-500">{t("To'g'ri javob uchun XP")}</span>
          <h2 className="mb-4 flex items-center gap-2 text-5xl font-bold text-black">
            +{Number.isInteger(totalXp) ? totalXp : 5} <XpIcon size={32} />
          </h2>
          <span className="text-center text-base font-medium text-gray-800">
            {t('tabriklaymiz_yakunlaganingiz_uchun')}
          </span>
          <div className="mb-4">
            <span className="font-medium text-green-600">+5 XP</span>{' '}
            <span className="text-base font-medium text-gray-800">{t('bonus')}</span>
          </div>
          <Button type="primary" onClick={onClose} className="!h-10 !rounded-lg !px-6 !text-base !font-medium">
            {t('natijani_batafsil_korish')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default XpModal;
